import {useEffect, useContext, useState, useMemo} from 'react';
import systemContext from "../../_context/systemContext";
import {obtenerFechaMenosDias} from '../../functions';
import Spinner from 'react-bootstrap/Spinner';
import { Link, Navigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap'
import { 
  AiOutlineDollar,
  AiOutlineClockCircle,
  AiOutlineSetting,
  AiOutlineNotification,
} from "react-icons/ai";
import { BsArrowRight } from "react-icons/bs";
import '../../Bienvenida.css'; // Archivo CSS adicional para los nuevos estilos

const Bienvenida = () => { 
    console.log('🔄 Bienvenida renderizado');
    const SystemContext = useContext(systemContext);
    const user = SystemContext.getUser();
    const { isManager, isProv, isComprasN } = useMemo(() => ({
        isAdmin: user && user.profile === 'Administrador',
        isConf: user && user.profile === 'Configuracion',
        isAuth: user && user.profile === 'Autorizacion'
    }), [user]);
    const [loading, setLoading] = useState(false);
    const [mensaje, setMensaje] = useState('');

    function LoaderModal({ show }) {
        return (
            <Modal show={show} backdrop="static"  keyboard={false} centered>
            <Modal.Body className="text-center">
                <Spinner animation="border" role="status" className="mb-3" />
                <h5>Cargando información...</h5>
            </Modal.Body>
            </Modal>
        );
    }

    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 100);
    }, []);
   
    /* useEffect(() => {
        fetch('/jsonConfig/MensajeInicio.json')
          .then((response) => response.json())
          .then((data) => {
            if (data.mensajes.length > 0)
                setMensaje(data.mensajes[0].bienvenida ?? "");
          })
          .catch((error) => console.error('Error al cargar el JSON:', error));
    }, []); 

    useEffect(() => {
        // Ocultar animación de bienvenida después de 3 segundos
        const timer = setTimeout(() => {
            setShowWelcomeAnimation(false);
        }, 3000);
        
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        console.log('🔄 useEffect ejecutado');
        const cargarDatos = async () => {
        setLoading(true);
        const start = Date.now();
        if (isProv) {
            await Promise.all([
                getTotalOC(),
                getTotalPagos(),
                getTotalFacturas(),
                getDatosProv(),
                getProveedoresCompras()
            ]);
        }
         else if (isComprasN) {
            if (user.dataprovs.length === 0)
                await getProveedoresComprasN();
        }
        const elapsed = Date.now() - start;
        const delay = elapsed < 500 ? 500 - elapsed : 0;
        setTimeout(() => setLoading(false), delay);
    };
    if (isProv || isComprasN)
        cargarDatos();
    else 
        setLoading(false);
    }, [isProv, isComprasN]); */

    /* const getTotalOC = async () => {
        try {
            const respuesta = await axios.get(urlOc);
            if (respuesta.data.Estatus[0].IdEstatus > 0)
                setTotalOC(respuesta.data.Estatus[0].ordenesdecompra.length);
        } catch (error) {
            console.error('Error al obtener Ordenes de compra: - ', error);
        }
    }
    const getTotalPagos = async () => {
        try {
            const respuesta = await axios.get(urlPagos);
            if (respuesta.data.Estatus[0].IdEstatus > 0)
                setTotalPagos(respuesta.data.Estatus[0].Pagos.length);
        } catch (error) {
            console.error('Error al obtener pagos emitidos: - ', error);
        }
    }
    const getTotalFacturas = async () => {
        try {
            const respuesta = await axios.get(urlFacturas);
            if (respuesta.data.Estatus[0].IdEstatus > 0 && Array.isArray(respuesta.data.Estatus[0].Facturas))
                setTotalFacturas(respuesta.data.Estatus[0].Facturas.length);
        } catch (error) {
            console.error('Error al obtener facturas: - ', error);
        }
    }
    const getDatosProv = async () => {
        try {
            const respuesta = await axios.get(urlUser);
            setNombreProv(respuesta.data.Estatus[0].Usuarios[0].Nombre);
            const respuestaSAP = await sapService.getProveedores(user.name);
            const datosProv = respuestaSAP.content.proveedores;
            const sociedades = datosProv.map(proveedor => proveedor.sociedad);
            user.sociedades = sociedades;
            const SociedadExiste = sociedadesArranqueSAP.some(sociedad => 
                sociedades.includes(sociedad)
            );
            user.esSAP = SociedadExiste;
            if (user.esSAP)
            {
                 const miObjetoJSON = {
                    "proveedor": user.name,
                    "fechaInicio": FechaFiltro
                };
                const respuestaSAPOC = await sapService.getOC(user.name);
                if (respuestaSAPOC.status === "OK")
                    setTotalOC(prevTotal => prevTotal + respuestaSAPOC.content.ordenescompra.length);
                const respuestaSAPFact = await sapService.getFacturas(miObjetoJSON);
                if (respuestaSAPFact.status === "OK" && Array.isArray(respuestaSAPFact.content?.facturas))
                    setTotalFacturas(prevTotal => prevTotal + respuestaSAPFact.content.facturas.length);
                const respuestaSAPPE = await sapService.getPagosE(miObjetoJSON);
                if (respuestaSAPPE.status === "OK" && Array.isArray(respuestaSAPPE.content?.pagos))
                    setTotalPagos(prevTotal => prevTotal + respuestaSAPPE.content.pagos.length);
            }
        } catch (error) {
            console.error('Error al obtener proveedor: - ', error);
        }
    }
    
    const getProveedoresCompras = async () => {
        try {
            const respuesta = await usersService.getProveedoresAsignados(user.name);
            const newProveedores = respuesta.content.users;
            if (newProveedores.length > 0)
            {
                user.profile = 'Compras';
                user.dataprovs = newProveedores;
            }           
        } catch (error) {
            console.error('Error al obtener proveedores: - ', error);
        }
    }

    const getProveedoresAdmin = async () => {
        try {
            const urlapiProvsQ = apiUrl + "Usuarios?IPUSUARIO=";
            const urlapiProvsFS = apiUrlFS + "Usuarios?IPUSUARIO=";
            const [respuestaQ, respuestaFS] = await Promise.all([
                axios.get(urlapiProvsQ),
                axios.get(urlapiProvsFS)
            ]);
            const ProveedoresQ = respuestaQ.data.Estatus[0].Usuarios || [];
            const ProveedoresFS = respuestaFS.data.Estatus[0].Usuarios || [];
            if (ProveedoresQ.length > 0 || ProveedoresFS.length > 0) {
                const combined = [...ProveedoresQ, ...ProveedoresFS];
                const unique = Array.from(
                    new Map(combined.map(p => [p.idUsuario, p])).values()
                );
                user.dataprovs = unique;
            }
        } catch (error) {
            console.error('Error al obtener proveedores: - ', error);
        }
    }

    const getProveedoresComprasN = async () => {
        try {
            user.profile = 'ComprasN';
        } catch (error) {
            console.error('Error al obtener proveedores: - ', error);
        }
    } */

    // if (user.resetPswd === 0) {
    //      return <Navigate to={`/catalogs/detail/${user.id}?reset=1`} />;
    //  }

    return(
    <>
    {loading ? (
        <div className="nova-loader-balanced">
            <div className="nova-spinner-balanced"></div>
            <p className="nova-loading-balanced">Cargando información...</p>
        </div>
    ) : (
        <div className="nova-dashboard-balanced">
            {/* Hero Balanceado */}
            <div className="nova-hero-balanced">
                <div className="nova-hero-balanced-bg">
                    <div className="nova-balanced-graphics">
                        <div className="balanced-orb bo-1"></div>
                        <div className="balanced-orb bo-2"></div>
                        <div className="balanced-orb bo-3"></div>
                    </div>
                </div>
                
                <div className="nova-hero-balanced-content">
                    <div className="balanced-brand">
                        <h1 className="balanced-app-title">Portal venta sin cargo</h1>
                        <p className="balanced-app-subtitle">Sistema de administración</p>
                    </div>
                    
                    <div className="balanced-welcome">
                        <h2 className="balanced-greeting">
                            Bienvenido <span className="balanced-username">{user?.nombre || 'Usuario Prueba '}</span>
                        </h2>
                        {/* <p className="balanced-description">Plataforma Unificada de Servicios</p> */}
                        <p className="balanced-company">QUALTIA ALIMENTOS OPERACIONES S. DE R.L. DE C.V.</p>
                    </div>
                </div>

                {mensaje.length > 0 && (
                    <div className="balanced-notification">
                        <AiOutlineNotification className="balanced-notification-icon" />
                        <div className="balanced-notification-text">
                            <strong>INFORMACIÓN RELEVANTE:</strong> {mensaje}
                        </div>
                    </div>
                )}
            </div>

            {/* Grid de Tarjetas Balanceadas */}
            <div className="nova-grid-balanced">
                <Link to="/saldo" className="nova-card-balanced">
                    <div className="balanced-card-icon">
                        <AiOutlineDollar />
                    </div>
                    <h3>Consulta de saldo disponible</h3>
                    <p>Control y seguimiento</p>
                    {/* {totalSaldos > 0 && <span className="balanced-badge">{totalSaldos}</span>} */}
                    <div className="balanced-arrow">
                        <BsArrowRight />
                    </div>
                    <div className="balanced-hover-effect"></div>
                </Link>
                <Link to="/cat" className="nova-card-balanced">
                    <div className="balanced-card-icon">
                        <AiOutlineClockCircle />
                    </div>
                    <h3>Catálogos</h3>
                    <p>Gestión de catálogos del portal</p>
                    <div className="balanced-arrow">
                        <BsArrowRight />
                    </div>
                    <div className="balanced-hover-effect"></div>
                </Link>
                <Link to="configuracion" className="nova-card-balanced">
                    <div className="balanced-card-icon">
                        <AiOutlineSetting />
                    </div>
                    <h3>Configuración</h3>
                    <p>Ajustes del sistema</p>
                    <div className="balanced-arrow">
                        <BsArrowRight />
                    </div>
                    <div className="balanced-hover-effect"></div>
                </Link>
                {/* <Link to="#" className="nova-card-balanced">
                    <div className="balanced-card-icon">
                        <AiOutlineNotification />
                    </div>
                    <h3>Avisos y Manuales</h3>
                    <p>Noticias y manuales de uso del portal</p>
                    <div className="balanced-arrow">
                        <BsArrowRight />
                    </div>
                    <div className="balanced-hover-effect"></div>
                </Link> */}
            </div>
        </div>
    )}
    </>
)
}

export default Bienvenida;